"use strict";

// Touch gestures for the mobile drawers and popups: swipe a drawer back the
// way it slid in to close it, swipe right inside a menu sub-level to go back
// one level, and pull a popup down to dismiss it. Every gesture finishes by
// clicking the panel's own close or back control, so theme.js and
// collection.js stay the only code that owns open/close state.
(function () {
  if (!window.matchMedia("(pointer: coarse)").matches) return;

  const html = document.documentElement;
  const rtl = document.body.classList.contains("rtl");
  const toward = (side) => (side === "end") !== rtl ? 1 : -1;

  // dir: +1 means the panel closes by moving right/down, -1 left/up.
  const panels = [
    {
      panel: "#minicart_wrapper.open_drawer .minicart__wrapper.open",
      close: ".close-cart-button",
      axis: "x",
      dir: toward("end"),
    },
    {
      panel: "#CollectionSidebar.open",
      close: "close-filter",
      axis: "x",
      dir: toward("start"),
    },
    {
      when: "open-search",
      panel: ".search__type-popup.bls__drawer",
      close: ".btn-search-close",
      axis: "x",
      dir: toward("start"),
    },
    {
      when: "nav-open",
      panel: "nav.navigation",
      close: ":scope > close-menu",
      axis: "x",
      dir: toward("start"),
      back: true,
    },
    {
      panel: ".tingle-modal--visible",
      close: ".tingle-modal__close",
      move: ".tingle-modal-box",
      axis: "y",
      dir: 1,
    },
  ];

  // Touches that start on these keep their own horizontal behaviour.
  const ownsHorizontal =
    ".swiper, input[type=range], .noUi-target, .price-slider, .overflow-x-auto, [data-no-swipe]";

  const LOCK = 10;
  const DISMISS_RATIO = 0.3;
  const FLICK_SPEED = 0.5; // px per ms

  let g = null;

  function findPanel(target) {
    for (const p of panels) {
      if (p.when && !html.classList.contains(p.when)) continue;
      const el = target.closest(p.panel);
      if (el) return { ...p, el };
    }
    return null;
  }

  function deepestBack(nav) {
    const open = [...nav.querySelectorAll("menu-item.is-open")];
    const leaf = open.reverse().find(
      (item) => !item.parentElement.querySelector(".submenu menu-item.is-open")
    );
    return leaf ? leaf.parentElement.querySelector("back-menu") : null;
  }

  function scrolledToTop(el, stopAt) {
    for (let n = el; n && n !== stopAt.parentElement; n = n.parentElement) {
      if (n.scrollTop > 0) return false;
    }
    return true;
  }

  function moveEl(state) {
    return state.move ? state.el.querySelector(state.move) || state.el : state.el;
  }

  function reset(el) {
    el.style.removeProperty("transform");
    el.style.removeProperty("transition");
    el.style.removeProperty("opacity");
  }

  document.addEventListener(
    "touchstart",
    (e) => {
      if (e.touches.length !== 1) return (g = null);
      const p = findPanel(e.target);
      if (!p) return (g = null);
      const t = e.touches[0];
      g = {
        ...p,
        target: e.target,
        x: t.clientX,
        y: t.clientY,
        t: e.timeStamp,
        dx: 0,
        dy: 0,
        mode: null,
        back: p.back ? deepestBack(p.el) : null,
      };
    },
    { passive: true }
  );

  document.addEventListener(
    "touchmove",
    (e) => {
      if (!g || e.touches.length !== 1) return;
      const t = e.touches[0];
      g.dx = t.clientX - g.x;
      g.dy = t.clientY - g.y;

      if (!g.mode) {
        const ax = Math.abs(g.dx);
        const ay = Math.abs(g.dy);
        if (Math.max(ax, ay) < LOCK) return;
        const along = g.axis === "x" ? g.dx : g.dy;
        const horizontal = ax > ay;
        if (g.back && horizontal && g.dx * toward("end") > 0) {
          g.mode = "back";
        } else if (
          (g.axis === "x") === horizontal &&
          along * g.dir > 0 &&
          !(g.axis === "x" && g.target.closest(ownsHorizontal)) &&
          !(g.axis === "y" && !scrolledToTop(g.target, g.el))
        ) {
          g.mode = "dismiss";
          moveEl(g).style.transition = "none";
        } else {
          g = null;
          return;
        }
      }

      if (e.cancelable) e.preventDefault();
      if (g.mode === "dismiss") {
        const d = Math.max(0, (g.axis === "x" ? g.dx : g.dy) * g.dir) * g.dir;
        moveEl(g).style.transform =
          g.axis === "x" ? `translate3d(${d}px,0,0)` : `translate3d(0,${d}px,0)`;
      }
    },
    { passive: false }
  );

  function onEnd(e) {
    if (!g || !g.mode) return (g = null);
    const s = g;
    g = null;
    const el = moveEl(s);
    const along = (s.axis === "x" ? s.dx : s.dy) * (s.mode === "back" ? toward("end") : s.dir);
    const size = s.axis === "x" ? el.offsetWidth : el.offsetHeight;
    const speed = along / Math.max(1, e.timeStamp - s.t);
    const commit = e.type === "touchend" && (along > size * DISMISS_RATIO || speed > FLICK_SPEED);

    if (s.mode === "back") {
      if (commit) s.back.click();
      return;
    }
    el.style.transition = "transform 0.25s ease-out, opacity 0.25s ease-out";
    if (!commit) {
      el.style.transform = "";
      setTimeout(() => reset(el), 260);
      return;
    }
    const off = `${s.dir * 100}%`;
    el.style.transform = s.axis === "x" ? `translate3d(${off},0,0)` : `translate3d(0,${off},0)`;
    if (s.move) el.style.opacity = "0";
    const close = s.el.querySelector(s.close);
    setTimeout(() => {
      if (close) close.click();
      setTimeout(() => reset(el), 600);
    }, 200);
  }

  document.addEventListener("touchend", onEnd, { passive: true });
  document.addEventListener("touchcancel", onEnd, { passive: true });
})();
